import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Favoritos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHeart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
export default function Favoritos() {
    useEffect(() => { try { Modal.setAppElement('#root'); } catch(_){} }, []);
    const [favoritos, setFavoritos] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        cargarProductos();
        cargarFavoritos();
    }, [isFocused]);

    useEffect(() => {
        const onOpenFav = () => { if (!window.__favOpen){ window.__favOpen = true; setModalIsOpen(true); setIsFocused(true); } };
        const onCloseAll = () => { setModalIsOpen(false); setIsFocused(false); window.__favOpen = false; };
        window.addEventListener('open-favoritos', onOpenFav);
        window.addEventListener('close-all-overlays', onCloseAll);
        return () => { window.removeEventListener('open-favoritos', onOpenFav); window.removeEventListener('close-all-overlays', onCloseAll); };
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); setProductos(data.productos||[]); }catch(_){ setProductos([]);} setLoading(false); })
            .catch(()=>{ setLoading(false); });
    };

    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        if (window.__favOpen) return;
        window.__favOpen = true;
        setModalIsOpen(true);
        setIsFocused(true);
        try{ window.dispatchEvent(new Event('open-favoritos')); }catch(_){ }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
        window.__favOpen = false;
        try{ window.dispatchEvent(new Event('close-all-overlays')); }catch(_){ }
    };

    const eliminarProducto = (id) => {
        const updatedFavoritos = favoritos.filter(itemId => itemId !== id);
        setFavoritos(updatedFavoritos);
        localStorage.setItem('favoritos', JSON.stringify(updatedFavoritos));

    };

    return (
        <div>
            <button onClick={openModal} className='cartIcon'><FontAwesomeIcon icon={faHeart} /></button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
                ariaHideApp={false}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <button onClick={closeModal} className='deleteToCart'>Favoritos</button>
                </div>
                {favoritos?.length === 0 ? (
                    <p className='nohay'>No hay favoritos</p>
                ) : (
                    <div className="modal-content-cart">
                        {loading ? (
                            <p>Cargando...</p>
                        ) : (
                            <div>
                                {favoritos.map((id) => {
                                    const producto = productos.find(prod => prod.idProducto === id);
                                    if (!producto) return null;
                                    return (


                                        <div key={producto.idProducto} className='cardProductCart' >
                                            <Anchor to={`/producto/${producto?.idProducto}/${producto?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal} >
                                                <img src={(obtenerImagen(producto) && /^https?:/i.test(obtenerImagen(producto))) ? obtenerImagen(producto) : `${baseURL}/${String(obtenerImagen(producto)||'').replace(/^\//,'')}`} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{producto.titulo}</h3>
                                                <span>{producto.categoria}</span>
                                                <strong> {moneda} {producto?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>

                                            </div>
                                            <button onClick={() => eliminarProducto(id)} className='deleteFav'><FontAwesomeIcon icon={faHeart} /></button>
                                        </div>


                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </Modal>
        </div>
    );
}
